import { render, staticRenderFns } from "./Trademarks.vue?vue&type=template&id=5fbc25ac&scoped=true&lang=html&"
import script from "./Trademarks.vue?vue&type=script&lang=js&"
export * from "./Trademarks.vue?vue&type=script&lang=js&"
import style0 from "./Trademarks.vue?vue&type=style&index=0&id=5fbc25ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbc25ac",
  null
  
)

component.options.__file = "Trademarks.vue"
export default component.exports